import { render, staticRenderFns } from "./NewColorForm.vue?vue&type=template&id=67c824c8&scoped=true&"
import script from "./NewColorForm.vue?vue&type=script&lang=js&"
export * from "./NewColorForm.vue?vue&type=script&lang=js&"
import style0 from "./NewColorForm.vue?vue&type=style&index=0&id=67c824c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c824c8",
  null
  
)

export default component.exports